module.exports = __webpack_public_path__ + "media/images/report-b05c32aff2e3a2180568c612bc767088.png";